module.exports = __webpack_public_path__ + "static/img/12.8e6420c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/12.jpg
// module id = mFsB
// module chunks = 1